import React from 'react';
import { Box } from '@mui/material';
import ComingSoon from '../../Components/ComingSoon';

const RosterDues: React.FC = () => {
  return (
    <Box>
      <ComingSoon
        title="Roster & Dues"
        subtitle="Manage Chapter Roster and Dues"
        description="Validate your chapter membership roster and manage dues collection for the annual reporting period."
      />
    </Box>
  );
};

export default RosterDues;
